import { addDays, format, parseISO } from 'date-fns';

import { TagTheme } from '@src/constants';
import { AppointmentType } from '@src/lib/__generated/beffe/sdk';
import { IsPayloadBody } from '@src/utils/build-intelligent-scheduling-payload';
import { fetchAvailableSlots } from '@src/utils/fetch-available-slots';
import getConfigByBrand from '@src/utils/get-config-by-brand';

const brandConfig = getConfigByBrand((process.env.TAG_BRAND_THEME || TagTheme.Lovet) as TagThemeType);

const getBeffeUrl = () =>
	process.env.BEFFE_GRAPHQL_URL ||
	(process.env.ENVIRONMENT_NAME === 'prod'
		? brandConfig.services.prod.BEFFE_GRAPHQL_URL
		: brandConfig.services.nonprod.BEFFE_GRAPHQL_URL);

export type IsPayload = {
	intelligentSchedulingEnabled: boolean;
	intelligentSchedulingPayload: IsPayloadBody | null;
};

// appointmentTypeId is kept for API compatibility with existing callers but is not forwarded
// to BEFFE — BEFFE filters by enum type internally.
export const checkSlotAvailability = async (
	locationId: number,
	appointmentTypeId: string,
	date: string,
	time: string,
	appointmentTypes?: AppointmentType[],
	isPayload?: IsPayload
) => {
	const dateTo = format(addDays(parseISO(date), 1), 'yyyy-MM-dd');

	const slots = await fetchAvailableSlots({
		beffeUrl: getBeffeUrl(),
		facilityId: String(locationId),
		appointmentTypes: appointmentTypes ?? [AppointmentType.Sick, AppointmentType.RoutineCheckup],
		dateFrom: date,
		dateTo,
		intelligentSchedulingEnabled: isPayload?.intelligentSchedulingEnabled ?? false,
		intelligentSchedulingPayload: isPayload?.intelligentSchedulingPayload ?? null,
	});

	return slots.some((slot) => slot.time === time);
};
